import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

type ToastTone = 'success' | 'danger' | 'warning' | 'medium';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastController = inject(ToastController);

  async error(message: string): Promise<void> {
    await this.present(message, 'danger', 'alert-circle-outline');
  }

  async success(message: string): Promise<void> {
    await this.present(message, 'success', 'checkmark-circle-outline');
  }

  async info(message: string): Promise<void> {
    await this.present(message, 'medium', 'information-circle-outline');
  }

  async warning(message: string): Promise<void> {
    await this.present(message, 'warning', 'warning-outline');
  }

  private async present(message: string, color: ToastTone, icon: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'bottom',
      color,
      icon,
      buttons: [{ text: 'Dismiss', role: 'cancel' }],
    });
    await toast.present();
  }
}
